import { render } from "./BuyukSehirButton.vue?vue&type=template&id=5fc9f206&scoped=true"
import script from "./BuyukSehirButton.vue?vue&type=script&lang=js"
export * from "./BuyukSehirButton.vue?vue&type=script&lang=js"

import "./BuyukSehirButton.vue?vue&type=style&index=0&id=5fc9f206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc9f206"]])

export default __exports__